export const reactionsConfig = {
  like: { icon: '👍', color: '#316FF6', name: 'Me gusta' },
  love: { icon: '❤️', color: '#E0245E', name: 'Me encanta' },
  haha: { icon: '😂', color: '#F7B125', name: 'Me divierte' },
  wow: { icon: '😮', color: '#F7B125', name: 'Me asombra' },
  sad: { icon: '😢', color: '#F7B125', name: 'Me entristece' },
  angry: { icon: '😠', color: '#E0245E', name: 'Me enoja' },
};

// 🟢 Exportamos el ícono por defecto que faltaba
export const defaultLikeIcon = 'fa-thumbs-up';